import faker from 'faker';
import dayjs from '@/helpers/dayjstz';

const networks = [1, 2, 3, 4, 18];

export default server => {
    server.get('/v1/account_events', (schema, { queryParams }) => {
        const { account_ids, context_id, context_type } = queryParams;

        const accountIds = Array.isArray(account_ids) ? account_ids : [account_ids];

        const startTime = dayjs(queryParams['range[from]']).unix();
        const endTime = dayjs(queryParams['range[to]']).unix();

        const selectedNetworks = faker.random.arrayElements(
            networks,
            faker.datatype.number({ min: 0, max: networks.length })
        );

        if (!selectedNetworks.length || (accountIds.length === 1 && accountIds[0] === '4')) {
            return [];
        }

        const timeDifference = parseInt((parseInt(endTime) - parseInt(startTime)) / 1000);

        const modifier =
            (timeDifference + parseInt(context_id || 5) * parseInt(context_type || 5)) * parseInt(accountIds.length);

        const stats = accountIds.map(id => {
            const selectedNetworks = faker.random.arrayElements(
                networks,
                faker.datatype.number({ min: 1, max: networks.length })
            );

            const accountModifier = id === '4' ? 0 : 1;

            return {
                account_id: id,
                counts: selectedNetworks.map(network => ({
                    social_type: network,
                    counts: {
                        assign: faker.datatype.number({ min: 0, max: 10 }) * modifier * accountModifier,
                        label: faker.datatype.number({ min: 0, max: 10 }) * modifier * accountModifier,
                        like: faker.datatype.number({ min: 0, max: 10 }) * modifier * accountModifier,
                        replies_private: faker.datatype.number({ min: 0, max: 10 }) * modifier * accountModifier,
                        replies_public: faker.datatype.number({ min: 0, max: 10 }) * modifier * accountModifier,
                        review: faker.datatype.number({ min: 0, max: 10 }) * modifier * accountModifier
                    }
                }))
            };
        });

        return stats;
    });

    server.get('/v1/account_events/labels', (schema, { queryParams }) => {
        const { account_ids, context_id, context_type } = queryParams;

        const accountIds = Array.isArray(account_ids) ? account_ids : [account_ids];

        const startTime = dayjs(queryParams['range[from]']).unix();
        const endTime = dayjs(queryParams['range[to]']).unix();

        const labelsCount = faker.datatype.number({ min: 0, max: 10 });

        if (!labelsCount || (accountIds.length === 1 && accountIds[0] === '4')) {
            return [];
        }

        const timeDifference = parseInt((parseInt(endTime) - parseInt(startTime)) / 1000);

        const modifier =
            (timeDifference + parseInt(context_id || 5) * parseInt(context_type || 5)) * parseInt(accountIds.length);

        const stats = [];

        for (let i = 0; i < labelsCount; i++) {
            const selectedNetworks = faker.random.arrayElements(
                networks,
                faker.datatype.number({ min: 1, max: networks.length })
            );

            const data = {
                name: faker.lorem.word(),
                counts: selectedNetworks.map(network => ({
                    social_type: network,
                    counts: faker.datatype.number({ min: 0, max: 10 }) * modifier
                }))
            };

            stats.push(data);
        }

        return stats;
    });
};
